import { Vue, Component } from "vue-property-decorator";

@Component({})
export default class UtilsService extends Vue {
  constructor() {
    super();
  }

  /**
   * @method objectMapper
   * @description 초기 값을 강제로 설정해야될 데이터에 초기 값 변경을 하여 반환
   * @param data 원본 데이터
   * @param mapper 초기 값을 세팅할 데이터
   */
  public objectMapper(data: any, mapper: any = {}): any {
    return Object.entries(data).reduce((acc: any, cur: any[]) => {
      let [key, value] = cur;
      value = !value && mapper.hasOwnProperty(key) ? mapper[key] : value;
      return { ...acc, [key]: value };
    }, {});
  }

  public disabledScroll(): void {
    const el: any = document.querySelector('html');
    el.style['overflow'] = 'hidden';
    el.style['height'] = '100%';
  }

  public activationScroll(): void {
    const el: any = document.querySelector('html');
    el.style['overflow'] = 'auto';
    el.style['height'] = 'auto';
  }
  
  public getStringBytes(s: string): number {
    if (s == null || s.length == 0) {
      return 0;
    }
    let size = 0;

    for (let i = 0; i < s.length; i++) {
      size += this.charByteSize(s.charAt(i));
    }

    return size;
  }

  public cutByteLength(s: string, len: number): string|number {
    if (s == null || s.length == 0) {
			return 0;
    }
    
		let size = 0;
		let rIndex = s.length;

		for ( var i = 0; i < s.length; i++) {
			size += this.charByteSize(s.charAt(i));
			if( size == len ) {
				rIndex = i + 1;
				break;
			} else if( size > len ) {
				rIndex = i;
				break;
			}
		}

		return s.substring(0, rIndex);
  }

  public charByteSize(ch: string): number {
    if (ch == null || ch.length == 0) {
      return 0;
    }

    const charCode = ch.charCodeAt(0);

    if (charCode <= 0x00007F) {
      return 1;
    } else if (charCode <= 0x0007FF) {
      return 2;
    } else if (charCode <= 0x00FFFF) {
      return 3;
    } else {
      return 4;
    }
  }

  public scrollTop(): void {
    window.scrollTo(0, 0);
  }
}